import AddIcon from '@mui/icons-material/Add';
import FilterListIcon from '@mui/icons-material/FilterList';
import {
  Button,
  FormControl,
  MenuItem,
  Select,
  SelectChangeEvent,
  Stack,
  TextField,
} from '@mui/material';
import { DC_LOCATIONS } from '../../constants/stores';
import useScreenMode from '../../Hooks/useScreenMode';
import { RestartAltTwoTone } from '@mui/icons-material';

type BolTopBarProps = {
  search?: string;
  onSearchChange?: (value: string) => void;

  allowLocation?: boolean;
  locationValue?: string;
  onLocationChange?: (value: string) => void;

  showFilterButton?: boolean;
  onOpenFilter?: () => void;

  showCreateButton?: boolean;
  onOpenCreate?: () => void;
  createLabel?: string;

  showResetButton?: boolean;
  onResetFilters?: () => void;
  resetLabel?: string;

  extraActions?: React.ReactNode;
};

export default function BolTopBar({
  search = '',
  onSearchChange,

  allowLocation = true,
  locationValue = 'All',
  onLocationChange,

  showFilterButton = true,
  onOpenFilter,

  showCreateButton = true,
  onOpenCreate,
  createLabel = 'Create BOL',

  showResetButton = true,
  onResetFilters,
  resetLabel = 'Reset Filters',

  extraActions,
}: BolTopBarProps) {
  const { isMobileLike } = useScreenMode();

  return (
    <Stack
      direction="row"
      spacing={1}
      alignItems="center"
      justifyContent="space-between"
      useFlexGap
      flexWrap="wrap"
      sx={{ width: '100%' }}
    >
      {/* Left section */}
      {/* <Stack
        direction="row"
        spacing={1}
        alignItems="center"
        useFlexGap
        flexWrap="wrap"
        sx={{
          flex: 1,
          minWidth: 0,
          width: isMobileLike ? '100%' : 'auto',
        }}
      >

      </Stack> */}

      {/* Right section */}
      <Stack
        direction="row"
        spacing={1}
        alignItems="center"
        useFlexGap
        flexWrap="wrap"
        sx={{
          width: isMobileLike ? '100%' : 'auto',
          justifyContent: isMobileLike ? 'flex-end' : 'flex-start',
          flexGrow: 1,
        }}
      >
        <TextField
          size="small"
          label="Search BOL"
          placeholder="Search BOL..."
          value={search}
          onChange={(e) => onSearchChange?.(e.target.value)}
          sx={{
            flex: 1,
            minWidth: isMobileLike ? 0 : 240,
          }}
        />
        {allowLocation && (
          <FormControl size="small" sx={{ minWidth: isMobileLike ? 120 : 180 }}>
            <Select
              size="small"
              value={locationValue || 'All'}
              onChange={(e: SelectChangeEvent) =>
                onLocationChange?.(e.target.value)
              }
            >
              {DC_LOCATIONS.map((loc) => (
                <MenuItem key={loc} value={loc}>
                  {loc === 'DC-Caledonia' ? 'DC-Richmond Hill' : loc}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}
        {extraActions}

        {showFilterButton && (
          <Button
            variant="outlined"
            onClick={onOpenFilter}
            sx={{
              minWidth: isMobileLike ? 40 : 'auto',
              px: isMobileLike ? 1 : 2,
            }}
          >
            <FilterListIcon />
            {!isMobileLike && 'Filters'}
          </Button>
        )}
        {showResetButton && (
          <Button
            variant="outlined"
            color="error"
            onClick={onResetFilters}
            sx={{
              minWidth: isMobileLike ? 'auto' : 'auto',
              px: isMobileLike ? 1 : 2,
            }}
          >
            <RestartAltTwoTone />
            {!isMobileLike && (resetLabel || 'Reset')}
          </Button>
        )}
        {showCreateButton && (
          <Button
            variant="contained"
            onClick={onOpenCreate}
            sx={{
              minWidth: isMobileLike ? 40 : 'auto',
              px: isMobileLike ? 1 : 2,
            }}
          >
            <AddIcon />
            {!isMobileLike && createLabel}
          </Button>
        )}
      </Stack>
    </Stack>
  );
}